import { ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { routes } from './app.routes';
import { FlatpickrModule } from 'angularx-flatpickr';
import { registerLocaleData } from '@angular/common';
import { RecaptchaModule } from 'ng-recaptcha';
import { provideToastr } from 'ngx-toastr';
import { AuthInterceptor } from './services/auth.interceptor';
import { NotificationService } from './services/notification.service';
import { SecureStorageService } from './services/secure-storage.service';
import { setSecureStorageInstance } from './helpers/utils';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

const secureStorage = new SecureStorageService();
setSecureStorageInstance(secureStorage);

/** Config partagée entre le navigateur et le serveur SSR. */
export const sharedAppConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })
    ),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    importProvidersFrom(
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      })
    ),
    NotificationService,
    { provide: SecureStorageService, useValue: secureStorage },
  ],
};

const browserConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideAnimations(),
    importProvidersFrom(FlatpickrModule.forRoot({})),
    importProvidersFrom(RecaptchaModule),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
};

export const appConfig = mergeApplicationConfig(sharedAppConfig, browserConfig);
